import React from 'react';

import {
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonList,
  IonRow,
} from '@ionic/react';
import { filterOutline } from 'ionicons/icons';

import Button from 'components/Button';
import { useSidePage } from 'components/Modal';
import Refresher from 'components/Refresher';
import {
  useScreenDispatch,
  useScreenState,
  withScreen,
} from 'components/Screen';
import TopToolbar from 'components/TopToolbar';
import { useQueryClient } from 'query';
import Chart from 'scenes/DashboardPage/components/Chart';

import FiltersModal from './components/FiltersModal';
import FiltersPrimary from './components/FiltersPrimary';
import RelativeUploadedTime from './components/RelativeUploadedTime';
import Widgets from './components/Widgets';
import { FILTERS, initialState } from './constants';
import { chart, summary } from './data/queryKeyFactory';
import screenReducer, { SET_FILTERS } from './screenReducer';

const DashboardPage: React.FC = () => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();
  const queryClient = useQueryClient();
  const [openFilters] = useSidePage(FiltersModal);

  const handleApplyPrimaryFilters = (filters: any) => {
    dispatch({
      type: SET_FILTERS,
      payload: filters,
    });
  };

  const handleOpenFiltersModal = () => {
    openFilters({
      initialValues: screenState.filters,
      defaultValues: initialState[FILTERS],
      onSubmit: (filters: any) => {
        dispatch({
          type: SET_FILTERS,
          payload: filters,
        });
      },
    });
  };
  const handleRefresh = async () => {
    await Promise.all([
      queryClient.invalidateQueries(chart()),
      queryClient.invalidateQueries(summary()),
    ]);
  };

  return (
    <>
      <IonHeader>
        <TopToolbar title={'Dashboard'}>
          <Button onClick={handleOpenFiltersModal}>
            <IonIcon slot={'icon-only'} icon={filterOutline} />
          </Button>
        </TopToolbar>
      </IonHeader>
      <IonContent>
        <Refresher onRefresh={handleRefresh} />
        <RelativeUploadedTime />
        <IonList lines={'full'} className={'primary-filters-container'}>
          <FiltersPrimary
            initialValues={screenState.filters}
            onSubmit={handleApplyPrimaryFilters}
          />
        </IonList>
        <IonGrid className={'ion-no-padding'}>
          <IonRow>
            <IonCol>
              <Chart />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <Widgets />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </>
  );
};

export default withScreen({
  screenReducer,
  initialState,
  name: 'DashboardPage',
})(React.memo(DashboardPage));
